

















import Vue from "vue";
import StepOption from "./StepOption.vue";
import { Option } from "../types";

export default Vue.extend({
  components: {
    StepOption: StepOption
  },
  name: "Step",
  props: {
    options: {
      type: Array as () => Array<Option>, // SUPER COOL!
      required: true
    }
  },
  computed: {
    selectedOptionIndex: function(): number {
      return this.options.findIndex(option => option.isSelected === true);
    }
  },
  methods: {
    handleSetSelectedOption(option: Option) {
      this.$emit("set-selected-option", option);
    }
  }
});
